/**
 * AI Bot 좌측 메뉴 — 메뉴디자이너에서만 노출된다.
 *
 * snotes-ai(aiStudio)로 전환한 뒤에는 임시저장·배포·조회쿼리 설정을 모두 Agent가
 * Tool로 처리하므로 버튼으로 둘 기능이 '새 채팅' 하나뿐이다. 나머지는 챗봇에
 * 자연어로 말한다 (예: "임시저장해줘", "배포해줘").
 *
 * 실행기는 디자이너 탭이 studioAiActions에 등록하므로, 여기서는 등록 여부만 보고
 * 호출한다 — 챗봇이 메뉴 모듈을 직접 import하지 않는다.
 */
import React from "react";
import AddIcon from "@mui/icons-material/Add";

interface Props {
  onNewChat: () => void;
  /** 디자이너 탭이 실행기를 등록했는가 (아니면 버튼 비활성) */
  isReady: boolean;
}

export default function DesignerSidebar({ onNewChat, isReady }: Props) {
  return (
    <aside className="chatbot-sidebar" aria-label="메뉴디자이너 작업 메뉴">
      <button
        className="chatbot-side-item"
        disabled={!isReady}
        onClick={onNewChat}
        title="진행 중인 대화와 편집 중인 화면을 비우고 새로 시작합니다"
        type="button"
      >
        <AddIcon fontSize="small" />
        <span>새 채팅</span>
      </button>

      <p className="chatbot-side-empty">
        임시저장·배포는 대화창에 말씀해 주세요.
        <br />
        (예: &quot;임시저장해줘&quot;, &quot;배포해줘&quot;)
      </p>
    </aside>
  );
}
